import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  connect() {
    this.initNewView();
    this.lanzarEventoCargado();
  }

  initNewView() {
    const nombre = this.element.querySelector('#grupo_nombre');
    const etiqueta = this.element.querySelector('#grupo_etiqueta');
    const selector = this.element.querySelector('#filtro_grupos');

    const actualizarEtiqueta = () => {
      const grupo = nombre.value;
      const path = this.selectorController.component.getSelectedPath();
      let etiquetaStr = `${(path[3] || {}).nombre} ${grupo} ${(path[1] || {}).abbr} ${(path[4] || {}).nombre}`;
      etiquetaStr = etiquetaStr.replace(/undefined/g, '').trim();
      etiqueta.value = etiquetaStr;
    };

    this.getControllerAsync(selector, 'selector-estructura')
      .then((selectorController) => {
        this.selectorController = selectorController;
        this.selectorController.component.on('clear option:selected', actualizarEtiqueta);
      });

    nombre.addEventListener('keyup', actualizarEtiqueta);
  }
}
